"use strict";
export function unmarshal(kv) {
  return kv;
}
export function marshal(obj) {
  return obj;
}
